import { LockReason } from '@shared/cards-types';

export const cardLock = {
    defaultLockReason: LockReason.THEFT,
    showDescription: false,
};
